import plansAPI from '@/api/plans';
import checkFor404 from '@/helpers/checkFor404';

export default {
  namespaced: true,

  state: () => ({
    plan: {
      name: null,
      sub_accounts: [],
      type: '',
      sub_type: '',
      main_account: {
        policy_number: null,
      },
      wrap: null,
      tags: [],
      client: {},
    },
    loaded: false,
    contributions: [],
    withdrawals: [],
    origin: 'client',
  }),

  getters: {
    getPlanFromState(state) {
      return state.plan;
    },
    getPlanType(state) {
      return state.plan.type;
    },
    isLoaded(state) {
      return state.loaded;
    },
  },

  actions: {
    setPlan({ commit }, plan) {
      commit('SET_PLAN', plan);
    },

    setLoaded({ commit }, value) {
      commit('SET_LOADED', value);
    },

    setContributions({ commit }, value) {
      commit('SET_CONTRIBUTIONS', value);
    },

    setWithdrawals({ commit }, value) {
      commit('SET_WITHDRAWALS', value);
    },

    async refreshPlan({ commit }, { plan_uuid }) {
      try {
        const { data } = await plansAPI.get(plan_uuid);
        commit('SET_PLAN', data.data);
        commit('SET_LOADED', true);
        return data.data;
      } catch (err) {
        checkFor404.process(err);
        throw err;
      }
    },
  },

  mutations: {
    SET_PLAN(state, plan) {
      state.plan = plan;
    },
    SET_LOADED(state, value) {
      state.loaded = value;
    },
    SET_CONTRIBUTIONS(state, value) {
      state.contributions = value;
    },
    SET_WITHDRAWALS(state, value) {
      state.withdrawals = value;
    },
    RESET_ORIGIN(state) {
      state.origin = 'client';
    },
    SET_ORIGIN(state, payload) {
      state.origin = payload;
    },
  },
};
